<!-- 币币交易 24小时行情 hdd -->
<template>
  <div class="current-symbol main-bg a-3-bd">
    <div class="operations-btn">
      <div class="symbol-total b-1-cl" @click.stop="showMarket">
        <i class="hoverHide" :class="{ 'b-4-cl': isShowMarket }">
          {{ activeContractName }}
          <!--<span class="triangle-down b-2-bd" :class="{ 'b-4-bd': isShowMarket }"></span>-->
          <svg-icon class='icon-triangle-down' icon-class="icon-triangle-down"></svg-icon>
        </i>
        <i class="hoverShow b-4-cl">
          {{ activeContractName }}
          <!--<span class="triangle-down b-4-bd"></span>-->
          <svg-icon class='icon-triangle-down' icon-class="icon-triangle-down"></svg-icon>
        </i>
      </div>

      <!-- 当前价格 -->
      <!-- <div class="info-item activePrice-item">
        <span class="tit activePrice" :class="activePriceClass">
          {{ thousandsComma(activeWsData.close) }}
          <i class="rose b-1-cl" :class="activeWsData.roseClass"> {{ activeWsData.rose }}% </i>
        </span>
      </div> -->

      <!-- <div class="set-button">
        <span class="a-3-bd" @click="showDialog('depositDialogShow')"> {{ marginModel }}</span>
        <span class="a-3-bd" @click="showDialog('leverageDialogShow')"> {{nowLevel}}X </span>
      </div> -->
    </div>
    <div class="symbol-info">
      <!-- 当前价格 -->
      <div class="info-item activePrice-item">
        <span class="tit activePrice" :class="activePriceClass">
          {{ thousandsComma(activeWsData.close) }}
        </span>
        <i class="rose" :class="activeWsData.roseClass"> {{ activeWsData.rose }}% </i>
      </div>
      <!-- 标记价格 -->
      <div class="info-item">
        <span class="tit explain gray-cl"> {{ $t("futures.currentSymbol.title1") }} </span>
        <span class="vla b-1-cl"> {{ thousandsComma(publicMarkertInfo.tagPrice) }} </span>
        <div class="explain-text main-second-bg a-3-bd b-1-cl">
          <i class="triangle main-second-bg a-3-bd"></i>
          <!-- 标记价格用于结算盈亏和触发强制平仓。标记价格可能会偏离市场最新价格，以防因市场被恶意操纵造成损失。 -->
          <!-- {{ $t('futures.currentSymbol.explain1')}} -->
          <p class="info-item-tips" v-html="lantext.explain1"></p>
        </div>
      </div>
      <!-- 指数价格 -->
      <div class="info-item">
        <span class="tit explain gray-cl"> {{ $t("futures.currentSymbol.title2") }} </span>
        <span class="vla b-1-cl"> {{ thousandsComma(publicMarkertInfo.indexPrice) }} </span>
        <div class="explain-text main-second-bg a-3-bd b-1-cl">
          <i class="triangle main-second-bg a-3-bd"></i>
          <p class="info-item-tips">
            <!-- 标的货币的市场公允现货价格。 -->
            {{ $t("futures.currentSymbol.explain2") }}
          </p>
        </div>
      </div>
      <!-- 本期资金费率 -->
      <div class="info-item">
        <span class="tit explain gray-cl">
          {{ $t("futures.currentSymbol.title3") }}/{{ capitalFrequency }}H
        </span>
        <span class="vla b-1-cl">
          {{ publicMarkertInfo.currentFundRate }}% / {{ countDownTime }}
        </span>
        <div class="explain-text main-second-bg a-3-bd b-1-cl">
          <i class="triangle main-second-bg a-3-bd"></i>
          <!-- 本期结束资金费率时将以此值进行结算。 -->
          <!-- <p>
            {{ activeTimer }}{{ $t("futures.currentSymbol.explain3") }}
          </p> -->
          <!-- 资金费每8小时结算一次（仅针对持仓用户），分别为UTC时间00:00，08:00，16:00
            资金费用=结算点实时资金费率*仓位价值
            仓位价值=仓位张数*面值*标记价格 -->
          <p class="info-item-tips" v-html="lantext.explain4"></p>
        </div>
      </div>
      <!-- 预测下期资金费率 -->
      <!-- 下期结算资金费时将以值进行结算。 -->
            <!-- {{ nextTimer }} -->
      <!-- <div class="info-item">
        <span class="tit explain gray-cl">{{ $t("futures.currentSymbol.title4") }} </span>
        <span class="vla b-1-cl"> {{ publicMarkertInfo.nextFundRate }}%</span>
        <div class="explain-text main-second-bg a-3-bd b-1-cl">
          <i class="triangle main-second-bg a-3-bd"></i>
          <p class="info-item-tips">
            {{ $t("futures.currentSymbol.explain5") }}
          </p>
          <p class="info-item-tips">
            {{ $t("futures.currentSymbol.explain6") }}
          </p>
        </div>
      </div> -->
            <!-- 资金费率为正则多头支付空头资金费，资金费率为负则空头支付多头资金费。 -->
      <!-- 24H成交量 -->
      <div class="info-item">
        <span class="tit gray-cl">{{ $t("futures.currentSymbol.title5") }}</span>
        <span class="vla b-1-cl"> {{ thousandsComma((activeWsData.vol * multiplier).toFixed(2)) }} {{ contractInfo && contractInfo.base }}</span>
      </div>
    </div>

    <!-- 市场 -->
    <!-- v-click-outside.capture="onClickOutside"
      v-click-outside:mousedown.capture="onClickOutside" -->
    <div class="market-shade u-7-bg" v-if="isShowMarket" @click="onClickOutside"></div>
    <div class="market-block" v-show="isShowMarket">
      <Market :isShow="isShowMarket" :close="closeDialog" />
    </div>
  </div>
</template>

<script>
import { directive as clickOutside } from 'v-click-outside-x';
import {
  nul, fixD, division, thousandsComma, getCookie, myStorage,
} from '@/utils';
import { fixUpDownColor } from '@/utils/storage';
// 24小时行情
import moment from 'moment';
import Market from './market.vue';

export default {
  // mixins: [mixin],
  components: { Market },
  directives: { clickOutside },
  mounted() {
    this.init();
  },
  data() {
    return {
      // 24小时行情数据
      WsData: {},
      // 是否显示市场
      isShowMarket: false,
      // 是否显示 合约设置弹框
      setFuturesIsShow: false,

      // 下次收取资金费率开始时间戳
      nextStartTime: null,
      // 下次收取资金费率开始时间倒计时
      countDownTime: null,
      // 倒计时
      setIntervalTimer: null,
      // 当前价格颜色的Class
      activePriceClass: '',
      // 轮训倒计时
      timer: null,
      // 本期结算时间
      activeTimer: null,
      // 下期结算时间
      nextTimer: null,
      // 当前合约市场id
      contractSide: myStorage.get('futuresMarketCurrent'),
      // 服务器时间,也要以utf8时区为准
      serverTime: moment().utcOffset(8).format('YYYY-MM-DD HH:mm:ss'),
    };
  },
  computed: {
    lantext() {
      return {
        explain1: this.$t('futures.currentSymbol.explain1'),
        explain4: this.$t('futures.currentSymbol.explain4'),
      };
    },
    // 是否登录
    isLogin() {
      return this.$store.state.baseData.isLogin;
    },
    // 当前合约信息
    contractInfo() {
      return this.$store.state.future.contractInfo;
    },
    // 资金费率间隔
    capitalFrequency() {
      if (this.contractInfo) {
        return this.contractInfo.capitalFrequency;
      }
      return 1;
    },
    // 当前合约名称
    activeContractName() {
      let name = '';
      let text = '';
      if (this.contractInfo) {
        const nameText = this.contractInfo.symbol ? this.contractInfo.symbol.replace('-', '') : '';
        if (this.contractInfo.contractType !== 'E') {
          text = `-${this.contractInfo.marginCoin}`;
        }
        name = `${nameText}${text}`;
      }
      return name;
    },
    // 当前合约面值
    multiplier() {
      return Number(this.$store.state.future.multiplier);
    },
    // 合约数量单位
    coUnit() {
      return this.$store.state.future.coUnit;
    },
    // 数量单位类型Number
    coUnitType() {
      return this.$store.state.future.coUnitType;
    },
    // 合约数量精度
    volfix() {
      return this.$store.state.future.volfix;
    },
    // 合约币对价格精度
    pricefix() {
      return this.$store.state.future.pricefix;
    },
    // 合约类型列表
    contractTypeText() {
      return this.$store.state.future.contractTypeText;
    },
    // 用户配置信息
    userConfig() {
      return this.$store.state.future.futureUserConfig;
    },
    // 当前合约保证金模式
    marginModel() {
      if (this.userConfig) {
        // 全仓 ： 逐仓
        return this.userConfig.marginModel === 1
          ? this.$t('futures.currentSymbol.marginModel1')
          : this.$t('futures.currentSymbol.marginModel2');
      }
      return this.$t('futures.currentSymbol.marginModel1');
    },
    // 当前合约杠杆倍数
    nowLevel() {
      if (this.userConfig) {
        return this.userConfig.nowLevel || '20';
      }
      return '20';
    },
    // 获取服务器和本地的时间差
    serveTimeDiff() {
      return this.$store.state.future.serveTimeDiff;
    },
    // 标记价格、指数价格、资金费率
    publicMarkertInfo() {
      const { publicMarkertInfo } = this.$store.state.future;
      if (publicMarkertInfo) {
        return {
          // 标记价格
          tagPrice: this.fixPrice(publicMarkertInfo.tagPrice),
          // 资金费率下次
          nextFundRate: this.fundRate(publicMarkertInfo.nextFundRate),
          // 指数价格
          indexPrice: this.fixPrice(publicMarkertInfo.indexPrice),
          // 本期资金费率
          currentFundRate: this.fundRate(publicMarkertInfo.currentFundRate),
        };
      }
      return {
        tagPrice: '--',
        nextFundRate: '--',
        currentFundRate: '--',
        indexPrice: '--',
      };
    },
    // 当前合约24小时行情数据
    activeWsData() {
      let obj = {
        close: '--',
        rose: '--',
        vol: '--',
        roseClass: '',
      };
      if (this.contractInfo && this.WsData) {
        const key = this.contractInfo.wsDatakey;
        if (this.WsData[key]) {
          const data = this.WsData[key];
          // 关闭当前合约价格
          this.$bus.$emit('ACTIVE_CONTRACT_PRICE', data.close);
          let { vol } = data;
          let roseClass = '';
          let slie = '';
          const val = parseFloat(data.rose, 0);
          if (val > 0) {
            roseClass = fixUpDownColor('u-1-cl');
            slie = '+';
          }
          if (val < 0) {
            roseClass = fixUpDownColor('u-4-cl');
            slie = '-';
          }
          if (val === 0) {
            roseClass = 'b-2-cl';
            slie = '-';
          }
          // 标的货币
          if (this.coUnitType === 1) {
            vol = fixD(nul(vol, this.multiplier), 0);
          }
          obj = {
            close: this.fixPrice(data.close),
            rose: `${slie}${this.fixdRose(data.rose)}`,
            vol,
            roseClass,
          };
        }
      }
      return obj;
    },
    publicInfo() {
      if (this.$store.state && this.$store.state.baseData) {
        return this.$store.state.baseData.publicInfo;
      }
      return null;
    },
    typeTabList() {
      // console.log(this.contractSide);
      if (this.contractSide === 1) {
        return this.$t('futures.market.text4'); // 'USDT合约',
      }
      if (this.contractSide === 0) {
        return this.$t('futures.market.text5'); // '币本位合约',
      }
      if (this.contractSide === 2) {
        return this.$t('futures.market.text6'); // '混合合约',
      }
      return this.$t('futures.market.text7'); // '模拟合约',
    },
    // 页面标题title
    documentTitle() {
      const lang = getCookie('lan');
      let str = '';
      if (this.publicInfo) {
        const { indexHeaderTitle, seo } = this.publicInfo;
        let title = '';
        if (indexHeaderTitle) {
          if (lang) {
            title = seo.title || indexHeaderTitle[lang];
          } else {
            const lan = this.publicInfo.lan.defLan;
            title = seo.title || indexHeaderTitle[lan];
          }
        }
        str = `${this.activeWsData.close}-${this.activeContractName} ${this.typeTabList} | ${title}`;
      }
      return str;
    },
  },
  watch: {
    // 页面标题title
    documentTitle(val) {
      document.title = val;
    },
    // 当前价格变化
    activeWsData(val, old) {
      if (val && old) {
        if (val.close !== '--' || old.close !== '--') {
          const newP = parseFloat(val.close, 0);
          const oldP = parseFloat(old.close, 0);
          if (newP > oldP) {
            this.activePriceClass = fixUpDownColor('u-1-cl');
          } else if (newP < oldP) {
            this.activePriceClass = fixUpDownColor('u-4-cl');
          } else if (newP !== oldP) {
            this.activePriceClass = '';
          }
        } else if (val !== old) {
          this.activePriceClass = '';
        }
      }
      this.$bus.$emit('activeWsData', { close: val.close, class: this.activePriceClass });
    },
    contractInfo(val) {
      if (val) {
        // 设置 资金费率倒计时
        this.setNextStartTime();
      }
    },
  },
  methods: {
    /**
     * 更新服务器时间
     * 拿到的服务器时间是东八区服务器时间,格式为'YYYY-MM-DD HH:mm:ss'
     * 因此,后边的计算不会受时区影响
     */
    setServerTime() {
      this.serverTime = moment(new Date().getTime() + this.serveTimeDiff).utcOffset(8).format('YYYY-MM-DD HH:mm:ss');
    },

    // 新价精度
    fixPrice(value) {
      if (value) {
        return fixD(value, this.pricefix);
      }
      return '--';
    },
    // 数量精度
    fixVol(value) {
      if (value) {
        return fixD(value, this.volfix);
      }
      return '--';
    },
    // 处理涨跌幅
    fixdRose(value) {
      if (value) {
        const num = Math.abs((value * 10000) / 100);
        return `${Number(num.toString().match(/^\d+(?:\.\d{0,2})?/))}`;
      }
      return '00.00';
    },
    // 处理资金费率
    fundRate(value) {
      if (value === 0) {
        return value;
      }
      if (value) {
        let slie;
        const val = parseFloat(value, 0);
        if (val > 0) {
          slie = '+';
        }
        if (val < 0) {
          slie = '-';
        }
        const num = Math.abs((value * 10000) / 100);
        // return `${slie}${Number(num.toString().match(/^\d+(?:\.\d{0,5})?/))}`;
        return `${slie}${fixD(num, 5)}`;
      }
      return '--';
    },
    // 设置下次收取资金费率开始时间戳
    setNextStartTime() {
      if (this.contractInfo) {
        // 开始时间
        let Time = this.contractInfo.capitalStartTime;
        // 一天结算次数
        const Len = division(24, this.capitalFrequency);
        const serverTime = new Date(this.serverTime);
        // 当前时间的小时数
        const NowH = serverTime.getHours();
        // 当天的的0点时间戳
        const TNS = new Date(serverTime.toLocaleDateString()).getTime();
        for (let index = 0; index < Len; index += 1) {
          if (NowH >= Time) {
            Time += this.capitalFrequency;
          }
        }

        // 本期结算时间
        this.activeTimer = Time > 9 ? `${Time}:00` : `0${Time}:00`;
        // 下期结算时间
        let nextTimer = Time + this.capitalFrequency;
        if (nextTimer > 24) {
          nextTimer -= 24;
        }
        if (nextTimer < 9) {
          nextTimer = `0${nextTimer}`;
        }
        this.nextTimer = `${nextTimer}:00`;
        this.nextStartTime = nul(Time, 3600000) + TNS;
        this.countdown();
      }
    },
    // 设置倒计时
    countdown() {
      clearInterval(this.setIntervalTimer);
      this.setIntervalTimer = setInterval(() => {
        this.setServerTime();
        // 获取当前时间
        const nowtime = new Date(this.serverTime).getTime();
        const lefttime = this.nextStartTime - nowtime; // 距离结束时间的毫秒数
        if (lefttime > 0) {
          let lefth = Math.floor(division(lefttime, 3600000) % 24); // 计算小时数
          let leftm = Math.floor(division(lefttime, 60000) % 60); // 计算分钟数
          let lefts = Math.floor(division(lefttime, 1000) % 60); // 计算秒数
          lefth = lefth < 10 ? `0${lefth}` : lefth;
          leftm = leftm < 10 ? `0${leftm}` : leftm;
          lefts = lefts < 10 ? `0${lefts}` : lefts;
          this.countDownTime = `${lefth}:${leftm}:${lefts}`; // 返回倒计时的字符串
        } else {
          this.setNextStartTime();
        }
      }, 1000);
    },
    // 开启弹框
    showDialog(type) {
      // 显示开通合约交易弹框
      if (this.userConfig && !this.userConfig.openContract) {
        this.$bus.$emit('OPEN_FUTURE');
        return false;
      }
      if (this.isLogin) {
        this.$store.dispatch('getUserConfig');
      }
      this[type] = true;
      return false;
    },
    // 关闭弹窗
    closeDialog() {
      // 关闭市场
      this.isShowMarket = false;
      // 关闭合约设置弹窗
      this.setFuturesIsShow = false;
      // 关闭杠杆弹窗
      this.leverageDialogShow = false;
      // 关闭切换保证金模式弹框
      this.depositDialogShow = false;
    },
    // 关闭市场
    onClickOutside() {
      this.isShowMarket = false;
    },
    // 显示 市场
    showMarket() {
      this.isShowMarket = !this.isShowMarket;
    },
    init() {
      // 获取前台公共实时信息(指数价格 标记价格 资金费率)
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.$store.dispatch('getPublicMarkertInfo');
      }, 5000);
      // 接收24小时行情数据
      this.$bus.$on('FUTURE_MARKET_DATA', (data) => {
        this.WsData = JSON.parse(data);
      });
      this.$bus.$on('futuresMarketCurrent', (data) => {
        this.contractSide = data;
      });
      this.setNextStartTime();
    },
    thousandsComma(num) {
      if (num) {
        return thousandsComma(num);
      }
      return num;
    },
  },
  destroyed() {
    this.$bus.$off('FUTURE_MARKET_DATA');
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>

<style lang="scss" scoped>
.current-symbol {
  height: 64px !important;
  border-bottom-width: 0;
  border-bottom-style: none;
  align-items: center;
  display: flex;
  position: relative;
  margin-bottom: 1px;

  .operations-btn {
    position: relative;
    z-index: 12;
    padding: 0 16px;
    height: 100%;

    // .activePrice-item {
    //  display: none;
    // }
  }

  .symbol-total {
    font-size: 16px;
    cursor: pointer;
    position: relative;
    user-select: none;
    line-height: 64px;
    height: 64px;

    .hoverShow {
      display: none;
    }

    &:hover {
      .hoverHide {
        display: none;
      }

      .hoverShow {
        display: block;
      }
    }
  }

  .symbol-info {
    height: 40px;
    display: flex;
    max-width: 800px;
    // justify-content: space-around;
    justify-content: flex-start;
    align-items: center;
    width: 80%;

    .info-item {
      font-size: 12px;
      position: relative;
      margin-left: 24px;

      &:first-child {
        margin-right: 16px;
      }

      span {
        display: block;
      }

      .explain {
        border-bottom-style: dashed;
        border-bottom-width: 1px;
        display: inline-block;
        cursor: pointer;
        font-weight: 400;
        font-size: 12px;
        line-height: 17px;
      }

      .tit {
        padding-bottom: 2px;
      }

      .vla {
        margin-top: 6px;
      }

      .explain-text {
        display: none;
        width: 200px;
        position: absolute;
        left: 50%;
        margin-left: -100px;
        z-index: 20;
        text-align: left;
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 17px;
        padding: 5px 8px;
        border-radius: 4px;
        top: 27px;
      }

      .triangle {
        position: absolute;
        top: -6px;
        left: 50%;
        margin-left: -5px;
        width: 10px;
        height: 10px;
        // border-left-width: 1px;
        // border-left-style: solid;
        // border-top-width: 1px;
        // border-top-style: solid;
        -webkit-transform: rotate(45deg);
        transform: rotate(45deg);
      }

      &:hover {
        .explain-text {
          display: block;
        }
      }
    }
  }

  .counter-and-set {
    flex: 1;
    display: none;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    padding-right: 16px;

    .hover-show {
      display: none;
    }

    .set-btn-icon {
      margin-left: 12px;
      cursor: pointer;

      &:hover {
        .hover-hide {
          display: none;
        }

        .hover-show {
          display: inline;
        }
      }
    }
  }

  .market-block {
    position: absolute;
    width: 310px;
    z-index: 100;
    top: 65px;
    left: 0;
  }

  .set-button {
    flex: 1;
    display: flex;
    max-width: 130px;
    padding-left: 5px;

    span {
      display: inline-block;
      width: 56px;
      text-align: center;
      height: 24px;
      line-height: 24px;
      border-width: 1px;
      border-style: solid;
      margin: 0 0 0 5px;
      cursor: pointer;
      user-select: none;
      font-size: 12px;
    }
  }

  .activePrice {
    line-height: 18px;
    font-size: 16px;
    font-weight: bold;

    i {
      font-size: 12px;
      padding: 0 5px;
      border-radius: 3px;
      font-weight: normal;
      margin-left: 3px;
    }
  }

  .market-shade {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 12;
    opacity: 0.1;
  }

  .triangle-down {
    width: 0;
    height: 0;
    border-left: 6px solid transparent !important;
    border-right: 6px solid transparent !important;
    border-top-width: 5px;
    border-top-style: solid;
    margin: -2px 0 0 4px;
    vertical-align: middle;
    padding: 0;
    display: inline-block;
  }

  .icon-triangle-down {
    font-size: 10px;
    margin-left: 5px;
    margin-bottom: 2px;
  }
}

@media screen and (max-width: 1451px) {
  .current-symbol {
    .operations-btn {
    }

    .symbol-info {
      width: 82%;
    }
  }
}
.info-item-tips {
  font-family: 'Medium';
}
</style>
